export function passwordReset(email: string) {
  return fetch(`${window.graphqlEndpoint}/password_reset`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  }).then((response) => response.json())
}

export function passwordResetWithToken(password: string, token: string) {
  return fetch(`${window.graphqlEndpoint}/password_reset`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ password, password_reset_token: token }),
  }).then((response) => response.json())
}
